import { decimalRound } from "./decimal-round";

/** Converts a file size in bytes to a human-friendly string. For example,
 * `toFileSizeString(2048)` will return `"2.00KB"`.
 */
export function toFileSizeString(n: number, precision = 2): string {
    if (n > Number.MAX_SAFE_INTEGER) {
        throw new Error(
            "Number is greater than MAX_SAFE_INTEGER; " +
                "toFileSizeString does not support orders of magnitude " +
                "higher than petabytes for this reason until BigInt " +
                "achieves broad browser support."
        );
    }
    const magnitude = Math.min(Math.floor(Math.log(n) / Math.log(1024)), 5);
    const unit = ["B", "KB", "MB", "GB", "TB", "PB"][magnitude];
    const decimalPlaces = magnitude ? precision : 0;
    return decimalRound(n / Math.pow(1024, magnitude), decimalPlaces).toFixed(decimalPlaces) + unit;
}
